import { DataTable } from '@components/Table/DataTable';
import { Pagination } from '@components/Table/Pagination';
import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableContainerProps, TableHead, TableRow } from '@material-ui/core';
import { IComboContratoOperadora } from '@model/ContratoOperadora';
import ILinha, { useLinhaDisponibilidadeColor } from '@model/Linha';
import { ILinhaFilter } from '@services/LinhaService';
import React from 'react';
import { LinhaEditarModal } from './LinhaEditarModal';

export type LinhaTableProps = {
    isLoading: boolean
    data: IData<ILinha, ILinhaFilter>
    tableContainerProps?: TableContainerProps
    menu: IMenu
    contratoOperadoraCombo: IComboContratoOperadora
}

export function LinhaTable ({ isLoading, data, tableContainerProps, menu, contratoOperadoraCombo }: LinhaTableProps) {
    const formatter = useFormatter();
    const detalheModal = useModalWindow();
    const linhaDisponibilidadeColor = useLinhaDisponibilidadeColor();

    return (
        <React.Fragment>
            <DataTable 
                isLoading={isLoading} 
                itemCount={data.itemsCount}
                tableContainerProps={tableContainerProps}
            >
                <TableHead>
                    <Pagination pagination={data.pagination} />

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="linhaId">ID</TableSortCell>
                        <TableSortCell fieldName="numeroSemMascara">Número</TableSortCell>
                        <TableSortCell fieldName="contratoOperadoraEmpresaNome">Empresa</TableSortCell>
                        <TableSortCell fieldName="contratoOperadoraOperadoraNome">Operadora</TableSortCell>
                        <TableSortCell fieldName="numeroContrato">Numero Contrato</TableSortCell>
                        <TableSortCell fieldName="disponibilidade">Disponibilidade</TableSortCell>
                        <TableHeaderCellAction />
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((linha, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{linha.linhaId}</TableKeyCell>
                                    <TableCell>{formatter.toCelular(linha.numeroSemMascara)}</TableCell>
                                    <TableCell>{linha.contratoOperadoraEmpresaNome}</TableCell>
                                    <TableCell>{linha.contratoOperadoraOperadoraNome}</TableCell>
                                    <TableCell>{linha.numeroContrato}</TableCell>
                                    <TableCell className={linhaDisponibilidadeColor[linha.disponibilidade]}>
                                        { linha.disponibilidade }
                                    </TableCell>

                                    <TableCellAction onButtonClick={data.handleRowFocused(linha, menu.open)} />
                                </TableRow>
                            )
                        })
                    }
                    <Pagination pagination={data.pagination} />
                </TableBody>
            </DataTable>

            {
                data.focusedRow !== undefined && (
                    <LinhaEditarModal 
                        linha={data.focusedRow}
                        modal={detalheModal}
                        contratoOperadoraCombo={contratoOperadoraCombo}
                        onLinhaEditada={data.handleUpdateFocusedRow}
                    />
                )
            }
        </React.Fragment>
    )
}